var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoom = function SvgZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 8.764c0 .538.438.974.974.974h1.298a.975.975 0 0 0 .974-.974V0H1.623C.727 0 0 .724 0 1.624z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.764 3.246a.975.975 0 0 0 .974-.974V.974A.975.975 0 0 0 8.764 0H.974A.975.975 0 0 0 0 .974v2.272zM30.512 8.764a.975.975 0 0 1-.974.974H28.24a.975.975 0 0 1-.974-.974V0h1.623c.896 0 1.623.724 1.623 1.624z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.75 3.246a.975.975 0 0 1-.975-.974V.974c0-.538.438-.974.974-.974h7.79c.538 0 .974.438.974.974v2.272zM0 21.749c0-.538.438-.974.974-.974h1.298c.538 0 .974.438.974.974v8.764H1.623A1.62 1.62 0 0 1 0 28.89z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.764 27.266c.538 0 .974.437.974.974v1.298a.975.975 0 0 1-.974.974H.974A.975.975 0 0 1 0 29.538v-2.272zM30.512 21.75a.975.975 0 0 0-.974-.975H28.24a.975.975 0 0 0-.974.974v8.764h1.623c.896 0 1.623-.724 1.623-1.624z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.75 27.266a.975.975 0 0 0-.975.974v1.298c0 .538.438.974.974.974h7.79a.975.975 0 0 0 .974-.974v-2.272z",
    clipRule: "evenodd"
  })));
};
export default SvgZoom;